export const env = {
  appBaseUrl: import.meta.env.VITE_APP_BASE_URL ?? 'https://seo-pictures.de',
  adminBaseUrl: import.meta.env.VITE_ADMIN_BASE_URL ?? 'https://seo-pictures.de/admin',
  devBaseUrl: import.meta.env.VITE_DEV_BASE_URL ?? 'https://dev.seo-pictures.de',
  cdnBaseUrl: import.meta.env.VITE_CDN_BASE_URL ?? 'https://cdn.seo-pictures.de',
  defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE ?? 'de',
  supportedLocales: (import.meta.env.VITE_SUPPORTED_LOCALES ?? 'de,en,fr,es,it,ar').split(','),
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  sentryWebDsn: import.meta.env.VITE_SENTRY_WEB_DSN,
  sentryAdminDsn: import.meta.env.VITE_SENTRY_ADMIN_DSN
};

export const envStatus = {
  hasSupabaseUrl: Boolean(env.supabaseUrl),
  hasSupabaseAnonKey: Boolean(env.supabaseAnonKey),
  hasSentryWebDsn: Boolean(env.sentryWebDsn),
  hasSentryAdminDsn: Boolean(env.sentryAdminDsn)
};
